// extracted by mini-css-extract-plugin
export default {"container":"Suggestion_container__6hkT4","request__date":"Suggestion_request__date__cFBFX","request__content":"Suggestion_request__content__PLJzW"};